/**
 * Types pour la gestion des Partners dans l'interface Admin
 */

export enum PartnerType {
  INSTITUTIONAL = 'INSTITUTIONAL',
  RETAIL = 'RETAIL',
  FEDERATION = 'FEDERATION',
}

export enum PartnerStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
  TERMINATED = 'TERMINATED',
}

export enum PartnerPlan {
  STARTER = 'STARTER',
  GROWTH = 'GROWTH',
  PREMIUM = 'PREMIUM',
  ENTERPRISE = 'ENTERPRISE',
}

export enum PartnerDisplayMode {
  EKAA_BRANDED = 'EKAA_BRANDED',
  HYBRID_BRANDING = 'HYBRID_BRANDING',
  WHITE_LABEL = 'WHITE_LABEL',
}

export interface PartnerWithStats {
  id: string;
  name: string;
  slug: string;
  description?: string;
  type: PartnerType;
  plan: PartnerPlan;
  status: PartnerStatus;
  isActive: boolean;
  logoUrl?: string;
  displayMode: PartnerDisplayMode;
  createdAt: string;
  enrollmentsCount: number;
  transactionsCount: number;
  totalRevenue: number;
  locationsCount: number;
  staffCount: number;
}

export interface PartnerDetail extends PartnerWithStats {
  palette?: any;
  customDomain?: string;
  walletConfig?: any;
  setupFeePaid: boolean;
  apiKey: string;
  webhookUrl?: string;
  webhookEvents: string[];
  typeConfig: any;
  updatedAt: string;
}

export interface AdminPartnerListResponse {
  items: PartnerWithStats[];
  total: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

export interface PartnersByTypeCount {
  type: PartnerType;
  count: number;
}

export interface PartnersByPlanCount {
  plan: PartnerPlan;
  count: number;
}

export interface AdminPartnerStats {
  totalPartners: number;
  pendingApproval: number;
  activePartners: number;
  suspendedPartners: number;
  byType: PartnersByTypeCount[];
  byPlan: PartnersByPlanCount[];
  totalEnrollments: number;
  totalRevenue: number;
  avgEnrollmentsPerPartner: number;
}

export interface PartnerAnalyticsItem {
  partnerId: string;
  partnerName: string;
  enrollments: number;
  transactions: number;
  revenue: number;
  pointsAwarded: number;
}

export interface TimeSeriesDataPoint {
  date: string;
  count: number;
  amount?: number;
}

export interface CrossPartnerAnalytics {
  totalEnrollments: number;
  totalTransactions: number;
  totalRevenue: number;
  totalPointsAwarded: number;
  topPartnersByEnrollments: PartnerAnalyticsItem[];
  topPartnersByRevenue: PartnerAnalyticsItem[];
  enrollmentsOverTime: TimeSeriesDataPoint[];
  revenueOverTime: TimeSeriesDataPoint[];
}

export interface AdminPartnerFilterInput {
  search?: string;
  type?: PartnerType;
  status?: PartnerStatus;
  plan?: PartnerPlan;
  createdAfter?: Date;
  createdBefore?: Date;
  sortBy?: 'name' | 'createdAt' | 'enrollments' | 'revenue';
  sortOrder?: 'asc' | 'desc';
}
